export const InsuranceMenuIcon = (props) => (
  <svg
    {...props}
    width={props?.width || '20'}
    height={props?.height || '20'}
    fill={'none'}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0002 18.3307C10.0002 18.3307 16.6668 14.9974 16.6668 9.9974V4.16406L10.0002 1.66406L3.3335 4.16406V9.9974C3.3335 14.9974 10.0002 18.3307 10.0002 18.3307Z"
      stroke={props?.color || '#101828'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
